export const STRINGS = {
  en: {
    ADD_CLASS_NAME: 'Class name*',
    ADD_CLASS_DESCRIPTION: 'Class description*',
    ANNUAL: 'Annual',
    ANONYMOUS: 'Anonymous',
    APPBAR_LOGO_TITLE: 'Bruce Studios Home',
    APPBAR_LOGO_ALT: 'Bruce Studios logo',
    APPBAR_HOME: 'Home',
    APPBAR_GET_STARTED: 'Get Started',
    APPBAR_STUDIOS: 'Studios',
    APPBAR_MEMBERSHIP: 'Membership',
    APPBAR_CREDITS: 'Credits',
    APPBAR_FAQ: 'FAQ',
    BRUCE_INFORMATION_TITLE: 'Bruce Studios is easy',
    BRUCE_INFORMATION_DESCRIPTION:
      'Choose a studio, book a class, scan our QR code when you arrive and you are all set.',
    BRUCE_INFORMATION_READ_MORE_BUTTON: 'Read more',
    COOKIE_DIALOG_ACCEPT: 'Accept all',
    COOKIE_DIALOG_ACCEPT_SETTINGS: 'Accept settings',
    COOKIE_DIALOG_CUSTOM: 'Change settings',
    COOKIE_DIALOG_DETAILED_INFO: [
      'Here you will find information on how we at Bruce Studios use cookies and pixels. During visits to our website, cookies are placed in all browsers and devices.',
      'Here we describe what a cookie is, in what way it is used, why we use them, and how visitors can choose cookies settings. We also describe how we treat pixels.',
      'Information on this page are subject to change.',
    ],
    COOKIE_DIALOG_INFO:
      'We use cookies to customize and analyze your browsing. We also share data with our advertisement partners.',
    COOKIE_DIALOG_READ_MORE: 'Read more',
    COOKIE_DIALOG_REJECT: 'Reject all',
    COOKIE_DIALOG_SUBTITLE_ADVANCED:
      'Used for collecting data that can help us understand how our website is being used and to get a better understanding of how users experience our website.',
    COOKIE_DIALOG_SUBTITLE_REQUIRED:
      'These cookies are used by our website to function. These types of cookies do not save personal data.',
    COOKIE_DIALOG_TITLE: 'Cookies and data protection',
    COOKIE_DIALOG_TOGGLE_ADVANCED: 'Advanced analysis and target audiences',
    COOKIE_DIALOG_TOGGLE_REQUIRED: 'Required cookies',
    CREDIT_CARD_LOGO: 'Bruce Studios',
    EMAIL_INVALID: 'Invalid email',
    ERROR_ACCESS_DENIED: 'Access denied',
    ERROR_BACK_TO_HOME: 'Go back to homepage',
    ERROR_INVALID_VERIFICATION: 'Invalid verification',
    ERROR_PAGE_NOT_FOUND: "The page you were looking for couldn't be found",
    ERROR_SOMETHING_WENT_WRONG: 'Something went wrong',
    ERROR_TRY_AGAIN: 'Try again',
    ERROR_TRY_ANOTHER_ACCOUNT: 'Try another account',
    FAQ_SEARCH: 'Search',
    FAQ_NO_RESULTS: 'No match found.',
    FAQ_CONTACT_DESCRIPTION:
      "Didn't find what you were looking for? Contact customer support and we'll help you out.",
    FAQ_CONTACT_BUTTON: 'Get in touch',
    FOOTER_ABOUT_US: 'About us',
    FOOTER_BECOME_A_PARTNER: 'Become a partner',
    FOOTER_CAREERS: 'Careers',
    FOOTER_FOLLOW_US: 'Follow us',
    FOOTER_GIFT_CARDS: 'Gift cards',
    FOOTER_LOGO_ALT: 'Bruce Studios logo',
    FOOTER_LOGO_TITLE: 'Bruce Studios Home',
    FOOTER_OCCUPATIONAL_HEALTH: 'Occupational health',
    FOOTER_PRIVACY: 'Privacy',
    FOOTER_TERMS: 'Terms',
    FROM: 'From',
    GIFT_CARD_TITLE: 'Gift Card',
    GIFT_CARD_SELECT: 'Select',
    LOGIN_EMAIL: 'Email',
    LOGIN_EMAIL_INVALID: 'Invalid email',
    LOGIN_PASSWORD: 'Password',
    LOGIN_LOGIN: 'Log in',
    LOGIN_OR_WITH_SOCIAL: 'Or continue with:',
    LOGIN_SIGNUP: 'Need an account? Create one here',
    LOGIN_FORGOT_PASSWORD: 'Forgot your password?',
    LOGIN_2FA_SETUP_DESCRIPTION:
      'Use a phone app like Google Authenticator, 1Password, Authy, LastPass Authenticator, or Microsoft Authenticator, etc. to get 2FA codes when prompted during sign-in.',
    LOGIN_2FA_SETUP_TITLE: 'Scan the QR code',
    LOGIN_2FA_SETUP_SCAN: 'Use an authenticator app from your phone to scan.',
    LOGIN_2FA_SETUP_VERIFY: 'Verify the code from the app',
    LOGIN_AUTHENTICATION_CODE: 'Authentication code',
    LOGIN_2FA_INVALID: 'Invalid or expired authentication code',
    LOGIN_2FA_REQUIRED: 'Authentication code is required',
    LOGIN_2FA_SETUP_REQUIRED: 'Two-factor authentication needs to be set up',
    LOGIN_UNAUTHORIZED: 'User not found or password did not match',
    LOGIN_TOO_MANY_REQUESTS: 'Too many auth attempts. Try again later.',
    IN: 'in',
    MEMBERSHIP_CARD_SELECT: 'Select',
    MEMBERSHIP_CARD_SAVE: 'Save',
    MEMBERSHIP_CARD_ANNUAL_FAQ: 'Find our FAQ for annual contract',
    MEMBERSHIP_CARD_ANNUAL_FAQ_LINK: 'here',
    MEMBERSHIP_CARD_ANNUAL_DISCLAIMER:
      'For the moment annual contract is only available for Base',
    MEMBERSHIP_CARDS_EXPLORE_ALL: 'Explore all',
    MEMBERSHIP_CARDS_FEATURED: 'Featured',
    MEMBERSHIP_CARDS_STUDIOS: 'studios',
    MEMBERSHIP_STEPPER_SELECT_MEMBERSHIP: 'Select membership',
    MEMBERSHIP_STEPPER_SIGNUP: 'Sign up',
    MEMBERSHIP_STEPPER_PAYMENT: 'Payment',
    MONTH: 'month',
    MONTH_SHORT: 'mon',
    MONTHLY: 'Monthly',
    OPEN_APP_BUTTON: 'Open in app',
    OPEN_APP_DEEP_LINK_NOTICE:
      'Did the app not open? Some browsers, such as SnapChat and Messenger, do not support opening the app directly. Try opening the link in a different browser.',
    PAYMENT_DETAILS_TITLE: 'Payment details',
    PAYMENT_DETAILS_ADD_NEW_PAYMENT_METHOD: 'Add new payment method',
    PAYMENT_DETAILS_PAY: 'Pay',
    PAYMENT_DETAILS_CHOOSE_PAYMENT_METHOD: 'Choose payment method',
    PAYMENT_DETAILS_TRY_AGAIN: 'Try again',
    PAYMENT_DETAILS_ANNUAL_INFO:
      'Please note that the selection of studios and classes at Bruce Studios may change even during your contract period. Read more in our',
    PAYMENT_DETAILS_FAQ: 'FAQ',
    PAYMENT_DETAILS_MEMBERSHIP_PAYMENT_INFO:
      'The first time you use Bruce Studios, you can cancel your membership during the first month without any notice period. After that, a 1 month notice period applies. This means you will be charged one more time after cancellation. Read more in our',
    PAYMENT_DETAILS_TERMS: 'terms and conditions',
    SHOPPING_CART_TITLE: 'Shopping cart',
    SHOPPING_CART_DISCOUNT: 'Discount',
    SHOPPING_CART_CAMPAIGN: 'Campaign',
    SHOPPING_CART_ANNUAL_CONTRACT_PERIOD: 'Annual contract period',
    SHOPPING_CART_START_DATE: 'Start date',
    SHOPPING_CART_END_DATE: 'End date',
    SHOPPING_CART_PAYMENT_PLAN: 'Payment plan',
    SHOPPING_CART_PREPAID: 'Prepaid',
    SHOPPING_CART_TO_PAY: 'To pay:',
    SHOPPING_CART_TO_PAY_TODAY: 'To pay today:',
    SHOPPING_CART_PAY_TODAY: 'Pay today',
    SHOPPING_CART_VALID_UNTIL: 'Valid until',
    SHOPPING_CART_TRY_FOR_FREE: 'Try for free',
    SHOPPING_CART_MEMBERSHIP: 'Membership:',
    SHOPPING_CART_CAMPAIGN_CODE: 'Campaign code',
    SHOPPING_CART_CAMPAIGN_CODE_ACTIVATE: 'Activate',
    SHOPPING_CART_TRIAL_TRANSITION: ['First payment on', 'will be'],
    SHOPPING_CART_GIFT_CARD: 'gift card',
    SHOPPING_CART_GIFT_CARD_MESSAGE: 'Personal message (optional)',
    SHOW_LESS: 'Show less',
    SHOW_MORE: 'Show more',
    SIGNUP_INVITE_CODE: 'Invite code',
    SIGNUP_EMAIL: 'Email',
    SIGNUP_FIRST_NAME: 'First name',
    SIGNUP_LAST_NAME: 'Last name',
    SIGNUP_YOUR_EMAIL: 'Your email',
    SIGNUP_YOUR_FIRST_NAME: 'Your first name',
    SIGNUP_YOUR_LAST_NAME: 'Your last name',
    SIGNUP_PASSWORD: 'Password',
    SIGNUP_EMAIL_INVALID: 'Invalid email',
    SIGNUP_FIRST_NAME_REQUIRED: 'First name is required',
    SIGNUP_LAST_NAME_REQUIRED: 'Last name is required',
    SIGNUP_PASSWORD_MIN_LENGTH: 'Password must be at least 8 characters long',
    SIGNUP_AGREE: ['I agree to Bruce Studios', 'and'],
    SIGNUP_TERMS: 'Terms',
    SIGNUP_PRIVACY_POLICY: 'Privacy Policy',
    SIGNUP_MARKETING_OPT_IN:
      'I agree to receive marketing emails from Bruce Studios.',
    SIGNUP_MARKETING_OPT_IN_MORE_INFO: 'More info',
    SIGNUP_CONTINUE: 'Continue',
    SIGNUP_WITH: 'with',
    SIGNUP_APP: 'Already a member? Click here',
    SIGNUP_LOGIN: 'Already have an account? Log in here',
    SIGNUP_OR_WITH_SOCIAL: 'Or sign up with:',
    STUDIO_MARKER_VIEW_STUDIO: 'View studio',
    TRIAL_BUTTON: 'Try Bruce Studios for 14 days',
    TRIAL_BUTTON_SHORT: 'Try for free',
    TRIAL_TITLE: 'Trial',
    TRIAL_META_TITLE: 'Try Bruce Studios for 14 days',
    TRIAL_USP_TITLE: 'Try Bruce Studios for 14 days',
    TRIAL_USPS: [
      '1 visit per studio is included.',
      'Cancel anytime before the trial ends.',
      'Access all studios included in Black for 14 days.',
      "After the trial, you'll automatically become a Black member with full access.",
      'Email reminder will be sent 2 days before your trial converts to a paid subscription.',
    ],
    TRIAL_READ_MORE: 'Read more',
    TRIAL_STEP: ['Step 1 of 2', 'Step 2 of 2'],
    TRIAL_DISCLAIMER: [
      'After the trial period has ended you will automatically start a',
      'membership for',
      'per month. If you cancel the trial, your access to studios will end. Rules for No shows, late cancels and late check-ins are the same as for regular members.',
    ],
    TRIAL_DISCLAIMER_READ_MORE: 'Read more here',
    TRIAL_FEATURED_STUDIOS_TITLE: 'Try these studios and many more',
    TRIAL_MORE_QUESTIONS: 'Got more questions? Visit our',
    TRIAL_FAQ_LINK: 'FAQ page',
    TRIAL_NOT_ACTIVE: 'Trial is currently not available in',
    USER_DETAILS_TITLE: 'User details',
    USER_DETAILS_NAME: 'Name',
    USER_DETAILS_PERSONAL_IDENTITY_NUMBER: 'Personal identity number',
    USER_DETAILS_MANUALLY_VERIFIED: 'Manually verified',
    USER_DETAILS_VERIFIED_WITH: 'Verified with',
    USER_DETAILS_CONTINUE_WITH: 'Continue with',
    USER_DETAILS_APPROVE_WITH_MIT_ID: 'Approve with',
    USER_DETAILS_MOBILE_BANK_ID: 'Mobile BankID on another device',
    USER_DETAILS_EXTEND_QR_CODE: 'Extend',
    USER_DETAILS_DONT_HAVE_EID_PROVIDER: "Don't have a",
    USER_DETAILS_CONTACT_SUPPORT: 'Contact our support to get help',
    USER_DETAILS_USER_ALREADY_EXISTS:
      "An account with the personal identity number already exists, but with a different email than the one entered. Don't have access to this email?",
    USER_DETAILS_TRY_AGAIN: 'Try again',
    USER_DETAILS_SOMETHING_WENT_WRONG:
      'Something went wrong with the verification.',
  },
  sv: {
    ADD_CLASS_NAME: 'Namn på pass*',
    ADD_CLASS_DESCRIPTION: 'Beskrivning av pass*',
    ANNUAL: 'Årlig',
    ANONYMOUS: 'Anonym',
    APPBAR_LOGO_TITLE: 'Bruce Studios Hem',
    APPBAR_LOGO_ALT: 'Bruce Studios logo',
    APPBAR_HOME: 'Hem',
    APPBAR_GET_STARTED: 'Kom igång',
    APPBAR_STUDIOS: 'Studios',
    APPBAR_MEMBERSHIP: 'Medlemskap',
    APPBAR_CREDITS: 'Credits',
    APPBAR_FAQ: 'Vanliga frågor',
    BRUCE_INFORMATION_TITLE: 'Bruce Studios är enkelt',
    BRUCE_INFORMATION_DESCRIPTION:
      'Välj en studio, boka ett pass, skanna vår QR-kod när du är framme och allt är klart.',
    BRUCE_INFORMATION_READ_MORE_BUTTON: 'Läs mer',
    COOKIE_DIALOG_ACCEPT: 'Godkänn alla',
    COOKIE_DIALOG_ACCEPT_SETTINGS: 'Godkänn inställningar',
    COOKIE_DIALOG_CUSTOM: 'Ändra inställningar',
    COOKIE_DIALOG_DETAILED_INFO: [
      'Här hittar du information om hur vi på Bruce Studios använder cookies och pixlar. Vid besök till vår sajt placerar vi cookies i alla webbläsare eller enheter.',
      'Här beskriver vi vad en cookie är, på vilket sätt och varför vi använder dem och hur du som besökare kan välja cookies-inställningar. Vi beskriver även vår behandling av pixlar.',
      'Informationen på sidan kan komma att ändras.',
    ],
    COOKIE_DIALOG_INFO:
      'Vi använder cookies för att anpassa och analysera din surfing. Vi delar också data med våra annonspartner.',
    COOKIE_DIALOG_READ_MORE: 'Läs mer',
    COOKIE_DIALOG_REJECT: 'Avvisa alla',
    COOKIE_DIALOG_SUBTITLE_ADVANCED:
      'Används för att samla data som kan hjälpa oss att förstå hur sajten används samt få bättre förståelse för hur användare upplever vår sajt.',
    COOKIE_DIALOG_SUBTITLE_REQUIRED:
      'Det här är cookies som vår sajt behöver för att fungera korrekt. Den här typen av cookies sparar inte personuppgifter.',
    COOKIE_DIALOG_TITLE: 'Cookies och dataskydd',
    COOKIE_DIALOG_TOGGLE_ADVANCED: 'Avancerad analys och målgrupper',
    COOKIE_DIALOG_TOGGLE_REQUIRED: 'Nödvändiga cookies',
    CREDIT_CARD_LOGO: 'Bruce Studios',
    EMAIL_INVALID: 'Ogiltig e-post',
    ERROR_ACCESS_DENIED: 'Åtkomst nekad',
    ERROR_BACK_TO_HOME: 'Gå tillbaka till startsidan',
    ERROR_INVALID_VERIFICATION: 'Ogiltig verifiering',
    ERROR_PAGE_NOT_FOUND: 'Sidan du letade efter hittades inte',
    ERROR_TRY_AGAIN: 'Försök igen',
    ERROR_TRY_ANOTHER_ACCOUNT: 'Försök med ett annat konto',
    ERROR_SOMETHING_WENT_WRONG: 'Något gick fel',
    FAQ_SEARCH: 'Sök',
    FAQ_NO_RESULTS: 'Ingen match hittad.',
    FAQ_CONTACT_DESCRIPTION:
      'Hittade du inte det du letade efter? Kontakta kundsupport här så hjälper vi dig.',
    FAQ_CONTACT_BUTTON: 'Kontakta oss',
    FOOTER_ABOUT_US: 'Om oss',
    FOOTER_BECOME_A_PARTNER: 'Bli partner',
    FOOTER_CAREERS: 'Karriär',
    FOOTER_FOLLOW_US: 'Följ oss',
    FOOTER_GIFT_CARDS: 'Presentkort',
    FOOTER_LOGO_ALT: 'Bruce Studios logo',
    FOOTER_LOGO_TITLE: 'Bruce Studios Hem',
    FOOTER_OCCUPATIONAL_HEALTH: 'Företagshälsa',
    FOOTER_PRIVACY: 'Integritet',
    FOOTER_TERMS: 'Villkor',
    FROM: 'Från',
    GIFT_CARD_TITLE: 'Presentkort',
    GIFT_CARD_SELECT: 'Välj',
    LOGIN_EMAIL: 'E-post',
    LOGIN_EMAIL_INVALID: 'Ogiltig e-post',
    LOGIN_PASSWORD: 'Lösenord',
    LOGIN_LOGIN: 'Logga in',
    LOGIN_OR_WITH_SOCIAL: 'Eller fortsätt med:',
    LOGIN_SIGNUP: 'Har du inget konto? Skapa ett här',
    LOGIN_FORGOT_PASSWORD: 'Glömt lösenordet?',
    LOGIN_2FA_SETUP_DESCRIPTION:
      'Använd en mobilapp som Google Authenticator, 1Password, Authy, LastPass Authenticator eller Microsoft Authenticator, etc. för att få 2FA-koder när du uppmanas till det när du loggar in.',
    LOGIN_2FA_SETUP_TITLE: 'Skanna QR-koden',
    LOGIN_2FA_SETUP_SCAN:
      'Använd en autentiseringsapp från din telefon för att skanna.',
    LOGIN_2FA_SETUP_VERIFY: 'Verifiera koden från appen',
    LOGIN_AUTHENTICATION_CODE: 'Autentiseringskod',
    LOGIN_2FA_INVALID: 'Ogiltig eller utgången autentiseringskod',
    LOGIN_2FA_REQUIRED: 'Autentiseringskod krävs',
    LOGIN_2FA_SETUP_REQUIRED: 'Tvåfaktorsautentisering måste konfigureras',
    LOGIN_UNAUTHORIZED:
      'Användaren hittades inte eller lösenordet matchade inte',
    LOGIN_TOO_MANY_REQUESTS: 'För många inloggningsförsök. Försök igen senare.',
    IN: 'i',
    MEMBERSHIP_CARD_SELECT: 'Välj',
    MEMBERSHIP_CARD_SAVE: 'Spara',
    MEMBERSHIP_CARD_ANNUAL_FAQ: 'Hitta vår FAQ för årsabonnemang',
    MEMBERSHIP_CARD_ANNUAL_FAQ_LINK: 'här',
    MEMBERSHIP_CARD_ANNUAL_DISCLAIMER:
      'För närvarande är årsabonnemang endast tillgängligt på Base',
    MEMBERSHIP_CARDS_EXPLORE_ALL: 'Utforska alla',
    MEMBERSHIP_CARDS_FEATURED: 'Utvalda',
    MEMBERSHIP_CARDS_STUDIOS: 'studios',
    MEMBERSHIP_STEPPER_SELECT_MEMBERSHIP: 'Välj medlemskap',
    MEMBERSHIP_STEPPER_SIGNUP: 'Skapa konto',
    MEMBERSHIP_STEPPER_PAYMENT: 'Betalning',
    MONTH: 'månad',
    MONTH_SHORT: 'mån',
    MONTHLY: 'Månatlig',
    OPEN_APP_BUTTON: 'Öppna i appen',
    OPEN_APP_DEEP_LINK_NOTICE:
      'Öppnades inte appen? Vissa webbläsare, som SnapChat och Messenger, stöder inte att öppna appen direkt. Försök att öppna länken i en annan webbläsare.',
    PAYMENT_DETAILS_TITLE: 'Betalningsuppgifter',
    PAYMENT_DETAILS_ADD_NEW_PAYMENT_METHOD: 'Lägg till ny betalningsmetod',
    PAYMENT_DETAILS_PAY: 'Betala',
    PAYMENT_DETAILS_CHOOSE_PAYMENT_METHOD: 'Välj betalningsmetod',
    PAYMENT_DETAILS_TRY_AGAIN: 'Försök igen',
    PAYMENT_DETAILS_ANNUAL_INFO:
      'Notera att Bruce Studios utbud av studios och pass kan komma att förändras även under tiden du är bunden. Läs mer i vår',
    PAYMENT_DETAILS_FAQ: 'FAQ',
    PAYMENT_DETAILS_MEMBERSHIP_PAYMENT_INFO:
      'Första gången du använder Bruce Studios kan du säga upp ditt medlemskap under den första månaden utan uppsägningstid. Därefter gäller 1 månads uppsägningstid. Det innebär att du debiteras 1 gång till efter uppsägningen. Läs mer i våra',
    PAYMENT_DETAILS_TERMS: 'användarvillkor',
    SHOPPING_CART_TITLE: 'Varukorg',
    SHOPPING_CART_DISCOUNT: 'Rabatt',
    SHOPPING_CART_CAMPAIGN: 'Kampanj',
    SHOPPING_CART_ANNUAL_CONTRACT_PERIOD: 'Årsavtal',
    SHOPPING_CART_START_DATE: 'Startdatum',
    SHOPPING_CART_END_DATE: 'Slutdatum',
    SHOPPING_CART_PAYMENT_PLAN: 'Betalningsplan',
    SHOPPING_CART_PREPAID: 'Förbetald',
    SHOPPING_CART_TO_PAY: 'Att betala:',
    SHOPPING_CART_TO_PAY_TODAY: 'Att betala idag:',
    SHOPPING_CART_PAY_TODAY: 'Betala idag',
    SHOPPING_CART_VALID_UNTIL: 'Giltigt till',
    SHOPPING_CART_TRY_FOR_FREE: 'Prova gratis',
    SHOPPING_CART_MEMBERSHIP: 'Medlemskap:',
    SHOPPING_CART_CAMPAIGN_CODE: 'Kampanjkod',
    SHOPPING_CART_CAMPAIGN_CODE_ACTIVATE: 'Aktivera',
    SHOPPING_CART_TRIAL_TRANSITION: ['Den', 'görs första dragningen på'],
    SHOPPING_CART_GIFT_CARD: 'presentkort',
    SHOPPING_CART_GIFT_CARD_MESSAGE: 'Personligt meddelande (valfritt)',
    SHOW_LESS: 'Visa mindre',
    SHOW_MORE: 'Visa mer',
    SIGNUP_INVITE_CODE: 'Inbjudningskod',
    SIGNUP_EMAIL: 'E-post',
    SIGNUP_FIRST_NAME: 'Förnamn',
    SIGNUP_LAST_NAME: 'Efternamn',
    SIGNUP_YOUR_EMAIL: 'Din e-post',
    SIGNUP_YOUR_FIRST_NAME: 'Ditt förnamn',
    SIGNUP_YOUR_LAST_NAME: 'Ditt efternamn',
    SIGNUP_PASSWORD: 'Lösenord',
    SIGNUP_EMAIL_INVALID: 'Ogiltig e-post',
    SIGNUP_FIRST_NAME_REQUIRED: 'Förnamn måste anges',
    SIGNUP_LAST_NAME_REQUIRED: 'Efternamn måste anges',
    SIGNUP_PASSWORD_MIN_LENGTH: 'Lösenordet måste vara minst 8 tecken långt',
    SIGNUP_AGREE: ['Jag godkänner Bruce Studios', 'och'],
    SIGNUP_TERMS: 'medlemsvillkor',
    SIGNUP_PRIVACY_POLICY: 'integritetspolicy',
    SIGNUP_MARKETING_OPT_IN:
      'Jag accepterar att ta emot marknadsföringsmail från Bruce Studios.',
    SIGNUP_MARKETING_OPT_IN_MORE_INFO: 'Mer info',
    SIGNUP_CONTINUE: 'Fortsätt',
    SIGNUP_WITH: 'med',
    SIGNUP_APP: 'Redan medlem? Klicka här',
    SIGNUP_LOGIN: 'Har du redan ett konto? Logga in här',
    SIGNUP_OR_WITH_SOCIAL: 'Eller registrera med:',
    STUDIO_MARKER_VIEW_STUDIO: 'Se studio',
    TRIAL_BUTTON: 'Prova gratis i 14 dagar',
    TRIAL_BUTTON_SHORT: 'Prova gratis',
    TRIAL_TITLE: 'Trial',
    TRIAL_META_TITLE: 'Prova gratis i 14 dagar',
    TRIAL_USP_TITLE: 'Prova gratis i 14 dagar',
    TRIAL_USPS: [
      '1 provträning per studio.',
      'Avsluta när som helst innan perioden är slut.',
      'Få tillgång till alla studios som ingår i Black i 14 dagar.',
      'Efter provperioden blir du automatiskt Blackmedlem med full access.',
      'Påminnelse via mail skickas två dagar innan prova-på-perioden övergår till ett betalande medlemskap.',
    ],
    TRIAL_READ_MORE: 'Läs mer',
    TRIAL_STEP: ['Steg 1 av 2', 'Steg 2 av 2'],
    TRIAL_DISCLAIMER: [
      'Efter provperioden påbörjar du automatiskt ett',
      'medlemskap för',
      'per månad. Om du avslutar provperioden upphör samtidigt din access att provträna på studios. Regler för No shows, sena avbokningar och sena incheckningar är detsamma som för ordinarie medlemmar.',
    ],
    TRIAL_DISCLAIMER_READ_MORE: 'Läs mer här',
    TRIAL_FEATURED_STUDIOS_TITLE: 'Prova dessa studios och många fler',
    TRIAL_MORE_QUESTIONS: 'Fler frågor? Besök vår',
    TRIAL_FAQ_LINK: 'FAQ-sida',
    TRIAL_NOT_ACTIVE: 'Trial är för nuvarande inte tillgängligt i',
    USER_DETAILS_TITLE: 'Dina uppgifter',
    USER_DETAILS_NAME: 'Namn',
    USER_DETAILS_PERSONAL_IDENTITY_NUMBER: 'Personnummer',
    USER_DETAILS_MANUALLY_VERIFIED: 'Manuellt verifierad',
    USER_DETAILS_VERIFIED_WITH: 'Verifierad med',
    USER_DETAILS_CONTINUE_WITH: 'Fortsätt med',
    USER_DETAILS_APPROVE_WITH_MIT_ID: 'Fortsätt med',
    USER_DETAILS_MOBILE_BANK_ID: 'Mobilt BankID på en annan enhet',
    USER_DETAILS_EXTEND_QR_CODE: 'Förläng',
    USER_DETAILS_DONT_HAVE_EID_PROVIDER: 'Har du inget',
    USER_DETAILS_CONTACT_SUPPORT: 'Kontakta vår support för att få hjälp',
    USER_DETAILS_USER_ALREADY_EXISTS:
      'Det finns redan ett annat konto kopplat till personnumret, men med en annan e-post än du har angett. Har du inte åtkomst till detta e-postkonto?',
    USER_DETAILS_TRY_AGAIN: 'Försök igen',
    USER_DETAILS_SOMETHING_WENT_WRONG: 'Något gick fel med verifikationen.',
  },
  nb: {
    ADD_CLASS_NAME: 'Navn på time*',
    ADD_CLASS_DESCRIPTION: 'Beskrivelse av time*',
    ANNUAL: 'Årlig',
    ANONYMOUS: 'Anonym',
    APPBAR_LOGO_TITLE: 'Bruce Studios Hjem',
    APPBAR_LOGO_ALT: 'Bruce Studios logo',
    APPBAR_HOME: 'Hjem',
    APPBAR_GET_STARTED: 'Kom i gang',
    APPBAR_STUDIOS: 'Studios',
    APPBAR_MEMBERSHIP: 'Medlemskap',
    APPBAR_CREDITS: 'Credits',
    APPBAR_FAQ: 'Vanlige spørsmål',
    BRUCE_INFORMATION_TITLE: 'Bruce Studios er enkelt',
    BRUCE_INFORMATION_DESCRIPTION:
      'Velg studio, book en time, skann QR-koden når du ankommer, og du er klar.',
    BRUCE_INFORMATION_READ_MORE_BUTTON: 'Les mer',
    COOKIE_DIALOG_ACCEPT: 'Aksepter alle',
    COOKIE_DIALOG_ACCEPT_SETTINGS: 'Aksepter innstillinger',
    COOKIE_DIALOG_CUSTOM: 'Endre innstillinger',
    COOKIE_DIALOG_DETAILED_INFO: [
      'Her finner du informasjon om hvordan vi i Bruce Studios bruker informasjonskapsler og piksler. Under besøk på nettsiden vår, er informasjonskapsler plassert i alle nettlesere og enheter.',
      'Her beskriver vi hva en informasjonskapsel er, på hvilken måte den brukes, hvorfor vi bruker dem, og hvordan besøkende kan velge innstillinger for informasjonskapsler. Vi beskriver også hvordan vi behandler piksler.',
      'Informasjonen på denne siden kan endres.',
    ],
    COOKIE_DIALOG_INFO:
      'Vi bruker informasjonskapsler for å tilpasse og analysere nettlesingen din. Vi deler også data med våre annonsepartnere.',
    COOKIE_DIALOG_READ_MORE: 'Les mer',
    COOKIE_DIALOG_REJECT: 'Avvise alle',
    COOKIE_DIALOG_SUBTITLE_ADVANCED:
      'Brukes til å samle inn data som kan hjelpe oss å forstå hvordan nettstedet vårt brukes og for å få en bedre forståelse av hvordan brukerne opplever nettstedet vårt.',
    COOKIE_DIALOG_SUBTITLE_REQUIRED:
      'Disse informasjonskapslene brukes av nettstedet vårt for å fungere. Denne typen informasjonskapsler lagrer ikke personopplysninger.',
    COOKIE_DIALOG_TITLE: 'Informasjonskapsler og databeskyttelse',
    COOKIE_DIALOG_TOGGLE_ADVANCED: 'Avansert analyse og målgrupper',
    COOKIE_DIALOG_TOGGLE_REQUIRED: 'Påkrevde informasjonskapsler',
    CREDIT_CARD_LOGO: 'Bruce Studios',
    EMAIL_INVALID: 'Ugyldig e-post',
    ERROR_ACCESS_DENIED: 'Ingen tilgang',
    ERROR_BACK_TO_HOME: 'Gå tilbake til hjemmesiden',
    ERROR_INVALID_VERIFICATION: 'Ugyldig verifisering',
    ERROR_PAGE_NOT_FOUND: 'Siden du lette etter ble ikke funnet',
    ERROR_SOMETHING_WENT_WRONG: 'Noe gikk galt',
    ERROR_TRY_AGAIN: 'Prøv igjen',
    ERROR_TRY_ANOTHER_ACCOUNT: 'Prøv en annen konto',
    FAQ_SEARCH: 'Søk',
    FAQ_NO_RESULTS: 'Ingen treff funnet.',
    FAQ_CONTACT_DESCRIPTION:
      'Fant du ikke det du lette etter? Kontakt kundesupport så hjelper vi deg.',
    FAQ_CONTACT_BUTTON: 'Ta kontakt',
    FOOTER_ABOUT_US: 'Om oss',
    FOOTER_BECOME_A_PARTNER: 'For treningssentre',
    FOOTER_CAREERS: 'Karriere',
    FOOTER_FOLLOW_US: 'Følg oss',
    FOOTER_GIFT_CARDS: 'Gavekort',
    FOOTER_LOGO_ALT: 'Bruce Studios logo',
    FOOTER_LOGO_TITLE: 'Bruce Studios Hjem',
    FOOTER_OCCUPATIONAL_HEALTH: 'Arbeidshelse',
    FOOTER_PRIVACY: 'Integritet',
    FOOTER_TERMS: 'Vilkår',
    FROM: 'Fra',
    GIFT_CARD_TITLE: 'Gavekort',
    GIFT_CARD_SELECT: 'Velg',
    LOGIN_EMAIL: 'E-post',
    LOGIN_EMAIL_INVALID: 'Ugyldig e-post',
    LOGIN_PASSWORD: 'Passord',
    LOGIN_LOGIN: 'Logg inn',
    LOGIN_OR_WITH_SOCIAL: 'Eller fortsett med:',
    LOGIN_SIGNUP: 'Har du ingen konto? Opprett her',
    LOGIN_FORGOT_PASSWORD: 'Glemt passordet?',
    LOGIN_2FA_SETUP_DESCRIPTION:
      'Bruk en app som Google Authenticator, 1Password, Authy, LastPass Authenticator eller Microsoft Authenticator osv. for å få 2FA-koder når du blir bedt om det under pålogging.',
    LOGIN_2FA_SETUP_TITLE: 'Skann QR-koden',
    LOGIN_2FA_SETUP_SCAN:
      'Bruk en autentiseringsapp fra telefonen for å skanne.',
    LOGIN_2FA_SETUP_VERIFY: 'Bekreft koden fra appen',
    LOGIN_AUTHENTICATION_CODE: 'Autentiseringskode',
    LOGIN_2FA_INVALID: 'Ugyldig eller utløpt autentiseringskode',
    LOGIN_2FA_REQUIRED: 'Autentiseringskode kreves',
    LOGIN_2FA_SETUP_REQUIRED: 'Tofaktorautentisering må settes opp',
    LOGIN_UNAUTHORIZED: 'Finner ikke brukeren eller passordet samsvarte ikke',
    LOGIN_TOO_MANY_REQUESTS: 'For mange påloggingsforsøk. Prøv igjen senere.',
    IN: 'i',
    MEMBERSHIP_CARD_SELECT: 'Velg',
    MEMBERSHIP_CARD_SAVE: 'Spar',
    MEMBERSHIP_CARD_ANNUAL_FAQ: 'Finn vår FAQ for årsabonnement',
    MEMBERSHIP_CARD_ANNUAL_FAQ_LINK: 'her',
    MEMBERSHIP_CARD_ANNUAL_DISCLAIMER:
      'Foreløpig er årsabonnement kun tilgjengelig for Base',
    MEMBERSHIP_CARDS_EXPLORE_ALL: 'Utforsk alle',
    MEMBERSHIP_CARDS_FEATURED: 'Utvalgte',
    MEMBERSHIP_CARDS_STUDIOS: 'studios',
    MEMBERSHIP_STEPPER_SELECT_MEMBERSHIP: 'Velg medlemskap',
    MEMBERSHIP_STEPPER_SIGNUP: 'Opprett konto',
    MEMBERSHIP_STEPPER_PAYMENT: 'Betaling',
    MONTH: 'måned',
    MONTH_SHORT: 'mnd',
    MONTHLY: 'Månedlig',
    OPEN_APP_BUTTON: 'Åpne i appen',
    OPEN_APP_DEEP_LINK_NOTICE:
      'Åpnet ikke appen? Noen nettlesere, som SnapChat og Messenger, støtter ikke åpning av appen direkte. Prøv å åpne lenken i en annen nettleser.',
    PAYMENT_DETAILS_TITLE: 'Betalingsinformasjon',
    PAYMENT_DETAILS_ADD_NEW_PAYMENT_METHOD: 'Legg til ny betalingsmetode',
    PAYMENT_DETAILS_PAY: 'Betale',
    PAYMENT_DETAILS_CHOOSE_PAYMENT_METHOD: 'Velg betalingsmetode',
    PAYMENT_DETAILS_TRY_AGAIN: 'Prøv igjen',
    PAYMENT_DETAILS_ANNUAL_INFO:
      'Vær oppmerksom på at utvalget av studioer og timer hos Bruce Studios kan endres selv i løpet av bindingstiden. Les mer i vår',
    PAYMENT_DETAILS_FAQ: 'FAQ',
    PAYMENT_DETAILS_MEMBERSHIP_PAYMENT_INFO:
      'Første gang du bruker Bruce Studios, kan du si opp medlemskapet ditt i løpet av den første måneden uten oppsigelsestid. Deretter gjelder 1 måneds oppsigelsestid. Det innebærer at du blir belastet én gang til etter oppsigelsen. Les mer i våre',
    PAYMENT_DETAILS_TERMS: 'brukervilkår',
    SHOPPING_CART_TITLE: 'Handlevogn',
    SHOPPING_CART_DISCOUNT: 'Rabatt',
    SHOPPING_CART_CAMPAIGN: 'Kampanje',
    SHOPPING_CART_ANNUAL_CONTRACT_PERIOD: 'Årlig avtaleperiode',
    SHOPPING_CART_START_DATE: 'Startdato',
    SHOPPING_CART_END_DATE: 'Sluttdato',
    SHOPPING_CART_PAYMENT_PLAN: 'Betalingsplan',
    SHOPPING_CART_PREPAID: 'Forhåndsbetalt',
    SHOPPING_CART_TO_PAY: 'Å betale:',
    SHOPPING_CART_TO_PAY_TODAY: 'Å betale i dag:',
    SHOPPING_CART_PAY_TODAY: 'Betal i dag',
    SHOPPING_CART_VALID_UNTIL: 'Gyldig til',
    SHOPPING_CART_TRY_FOR_FREE: 'Prøv gratis',
    SHOPPING_CART_MEMBERSHIP: 'Medlemskap:',
    SHOPPING_CART_CAMPAIGN_CODE: 'Kampanjekode',
    SHOPPING_CART_CAMPAIGN_CODE_ACTIVATE: 'Aktivere',
    SHOPPING_CART_TRIAL_TRANSITION: [
      'Det første trekket utføres den',
      ', og vil være på',
    ],
    SHOPPING_CART_GIFT_CARD: 'gavekort',
    SHOPPING_CART_GIFT_CARD_MESSAGE: 'Personlig melding (valgfritt)',
    SHOW_LESS: 'Vis mindre',
    SHOW_MORE: 'Vis mer',
    SIGNUP_EMAIL: 'E-post',
    SIGNUP_INVITE_CODE: 'Invitasjonskode',
    SIGNUP_FIRST_NAME: 'Fornavn',
    SIGNUP_LAST_NAME: 'Etternavn',
    SIGNUP_YOUR_EMAIL: 'Din e-post',
    SIGNUP_YOUR_FIRST_NAME: 'Ditt fornavn',
    SIGNUP_YOUR_LAST_NAME: 'Ditt etternavn',
    SIGNUP_PASSWORD: 'Passord',
    SIGNUP_EMAIL_INVALID: 'Ugyldig e-post',
    SIGNUP_FIRST_NAME_REQUIRED: 'Fornavn må oppgis',
    SIGNUP_LAST_NAME_REQUIRED: 'Etternavn må oppgis',
    SIGNUP_PASSWORD_MIN_LENGTH: 'Passord må inneholde minst 8 tegn',
    SIGNUP_AGREE: ['Jeg godkjenner Bruce Studios', 'og'],
    SIGNUP_TERMS: 'medlemsvilkår',
    SIGNUP_PRIVACY_POLICY: 'personvernerklæring',
    SIGNUP_MARKETING_OPT_IN:
      'Jeg godtar å motta markedsføringsmailer fra Bruce Studios.',
    SIGNUP_MARKETING_OPT_IN_MORE_INFO: 'Mer info',
    SIGNUP_CONTINUE: 'Fortsett',
    SIGNUP_WITH: 'med',
    SIGNUP_APP: 'Allerede medlem? Klikk her',
    SIGNUP_LOGIN: 'Har du allerede en konto? Logg inn her',
    SIGNUP_OR_WITH_SOCIAL: 'Eller registrer med:',
    STUDIO_MARKER_VIEW_STUDIO: 'Se studio',
    TRIAL_BUTTON: 'Prøv gratis i 14 dager',
    TRIAL_BUTTON_SHORT: 'Prøv gratis',
    TRIAL_TITLE: 'Trial',
    TRIAL_META_TITLE: 'Prøv gratis i 14 dager',
    TRIAL_USP_TITLE: 'Prøv gratis i 14 dager',
    TRIAL_USPS: [
      '1 prøvetrening per studio.',
      'Kanseller når som helst før prøveperioden utløper.',
      'Få tilgang til alle studios som er inkludert i Black i 14 dager.',
      'Etter prøveperioden blir du automatisk Black-medlem med full tilgang.',
      'Påminnelse via e-post sendes to dager før prøveperioden overgår til et betalende medlemskap.',
    ],
    TRIAL_READ_MORE: 'Les mer',
    TRIAL_STEP: ['Steg 1 av 2', 'Steg 2 av 2'],
    TRIAL_DISCLAIMER: [
      'Etter prøveperioden starter du automatisk et',
      'medlemskap for',
      'per måned. Hvis du avslutter prøveperioden, vil tilgangen til å prøvetrene også opphøre. Reglene for no-show, sen avbooking og sen innsjekking er de samme som for vanlige medlemmer',
    ],
    TRIAL_DISCLAIMER_READ_MORE: 'Les mer her',
    TRIAL_FEATURED_STUDIOS_TITLE: 'Prøv disse studios og mange flere',
    TRIAL_MORE_QUESTIONS: 'Har du flere spørsmål? Besøk vår',
    TRIAL_FAQ_LINK: 'FAQ-side',
    TRIAL_NOT_ACTIVE: 'Trial er foreløpig ikke tilgjengelig i',
    USER_DETAILS_TITLE: 'Din informasjon',
    USER_DETAILS_NAME: 'Navn',
    USER_DETAILS_PERSONAL_IDENTITY_NUMBER: 'Personnummer',
    USER_DETAILS_MANUALLY_VERIFIED: 'Manuelt verifisert',
    USER_DETAILS_VERIFIED_WITH: 'Verifisert med',
    USER_DETAILS_CONTINUE_WITH: 'Fortsett med',
    USER_DETAILS_APPROVE_WITH_MIT_ID: 'Fortsett med',
    USER_DETAILS_MOBILE_BANK_ID: 'Mobilt BankID på en annen enhet',
    USER_DETAILS_EXTEND_QR_CODE: 'Forleng',
    USER_DETAILS_DONT_HAVE_EID_PROVIDER: 'Har du ikke',
    USER_DETAILS_CONTACT_SUPPORT: 'Kontakt support for hjelp',
    USER_DETAILS_USER_ALREADY_EXISTS:
      'Det er allerede en annen konto knyttet til fødselsnummeret, men med en annen e-postadresse enn den du har oppgitt. Har du ikke tilgang til denne e-posten?',
    USER_DETAILS_TRY_AGAIN: 'Prøv igjen',
    USER_DETAILS_SOMETHING_WENT_WRONG: 'Noe gikk galt med verifiseringen.',
  },
  da: {
    ADD_CLASS_NAME: 'Navn på hold*',
    ADD_CLASS_DESCRIPTION: 'Beskrivelse af hold*',
    ANNUAL: 'Årlig',
    ANONYMOUS: 'Anonym',
    APPBAR_LOGO_TITLE: 'Bruce Studios Hjem',
    APPBAR_LOGO_ALT: 'Bruce Studios logo',
    APPBAR_HOME: 'Hjem',
    APPBAR_GET_STARTED: 'Kom i gang',
    APPBAR_STUDIOS: 'Studios',
    APPBAR_MEMBERSHIP: 'Medlemskab',
    APPBAR_CREDITS: 'Credits',
    APPBAR_FAQ: 'FAQ',
    BRUCE_INFORMATION_TITLE: 'Bruce Studios er nemt',
    BRUCE_INFORMATION_DESCRIPTION:
      'Vælg et studio, book en time, scan QR koden ved ankomst, så er alt klart.',
    BRUCE_INFORMATION_READ_MORE_BUTTON: 'Læs mere',
    COOKIE_DIALOG_ACCEPT: 'Accepter alle',
    COOKIE_DIALOG_ACCEPT_SETTINGS: 'Accepter indstillinger',
    COOKIE_DIALOG_CUSTOM: 'Ændre indstillinger',
    COOKIE_DIALOG_DETAILED_INFO: [
      'Her kan du finde information omkring, hvordan vi i Bruce Studios bruger cookies og pixels. Ved at besøge vores hjemmeside, er cookies tilføjet til alle browsers og devices.',
      'Her beskriver vi, hvad cookies er, hvordan vi bruger dem, hvorfor vi bruger dem og hvordan besøgende kan ændre cookies indstillinger. Vi beskriver også, hvordan vi behandler pixels.',
      'Information på denne side kan blive ændret løbende.',
    ],
    COOKIE_DIALOG_INFO:
      'Vi bruger cookies for at analysere og tilpasse din søgning. Vi deler også data med vores markedsføringspartnere.',
    COOKIE_DIALOG_READ_MORE: 'Læs mere',
    COOKIE_DIALOG_REJECT: 'Afvis alle',
    COOKIE_DIALOG_SUBTITLE_ADVANCED:
      'Bliver brugt til at indsamle data, som hjælper os med at forstå, hvordan vores hjemmeside bliver brugt og for at få en bedre forståelse af, hvordan besøgende oplever vores hjemmeside.',
    COOKIE_DIALOG_SUBTITLE_REQUIRED:
      'Disse cookies er brugt på vores hjemmeside for at den kan fungere. Denne type cookies gemmer ikke personlig data.',
    COOKIE_DIALOG_TITLE: 'Cookies og databeskyttelse',
    COOKIE_DIALOG_TOGGLE_ADVANCED: 'Nødvendige cookies',
    COOKIE_DIALOG_TOGGLE_REQUIRED: 'Advanceret analyse og målgrupper',
    CREDIT_CARD_LOGO: 'Bruce Studios',
    EMAIL_INVALID: 'Ugyldig e-mail',
    ERROR_ACCESS_DENIED: 'Adgang nægtet',
    ERROR_BACK_TO_HOME: 'Gå tilbage til startsiden',
    ERROR_INVALID_VERIFICATION: 'Ugyldig verifikation',
    ERROR_PAGE_NOT_FOUND: 'Den side, du ledte efter, kunne ikke findes',
    ERROR_SOMETHING_WENT_WRONG: 'Noget gik galt',
    ERROR_TRY_AGAIN: 'Prøv igen',
    ERROR_TRY_ANOTHER_ACCOUNT: 'Prøv en anden konto',
    FAQ_SEARCH: 'Søg',
    FAQ_NO_RESULTS: 'Ingen match fundet.',
    FAQ_CONTACT_DESCRIPTION:
      'Fandt du ikke det, du ledte efter? Kontakt kundesupporten her, så hjælper vi dig.',
    FAQ_CONTACT_BUTTON: 'Kontakt os',
    FOOTER_ABOUT_US: 'Om os',
    FOOTER_BECOME_A_PARTNER: 'Bliv partner',
    FOOTER_CAREERS: 'Karriere',
    FOOTER_FOLLOW_US: 'Følg os',
    FOOTER_GIFT_CARDS: 'Gavekort',
    FOOTER_LOGO_ALT: 'Bruce Studios logo',
    FOOTER_LOGO_TITLE: 'Bruce Studios Hjem',
    FOOTER_OCCUPATIONAL_HEALTH: 'Medarbejdersundhed',
    FOOTER_PRIVACY: 'Persondatapolitik',
    FOOTER_TERMS: 'Vilkår',
    FROM: 'Fra',
    GIFT_CARD_TITLE: 'Gavekort',
    GIFT_CARD_SELECT: 'Vælg',
    LOGIN_EMAIL: 'E-mail',
    LOGIN_EMAIL_INVALID: 'Ugyldig e-mail',
    LOGIN_PASSWORD: 'Adgangskode',
    LOGIN_LOGIN: 'Log ind',
    LOGIN_OR_WITH_SOCIAL: 'Eller fortsæt med:',
    LOGIN_SIGNUP: 'Har du ikke en konto? Opret en her',
    LOGIN_FORGOT_PASSWORD: 'Glemt adgangskoden?',
    LOGIN_2FA_SETUP_DESCRIPTION:
      'Brug en app som Google Authenticator, 1Password, Authy, LastPass Authenticator eller Microsoft Authenticator osv. for at få 2FA-koder, når du bliver bedt om det under login.',
    LOGIN_2FA_SETUP_TITLE: 'Scan QR-koden',
    LOGIN_2FA_SETUP_SCAN:
      'Brug en autentificeringsapp fra din telefon til at scanne.',
    LOGIN_2FA_SETUP_VERIFY: 'Bekræft koden fra appen',
    LOGIN_AUTHENTICATION_CODE: 'Autentificeringskode',
    LOGIN_2FA_INVALID: 'Ugyldig eller udløbet autentificeringskode',
    LOGIN_2FA_REQUIRED: 'Autentificeringskode er påkrævet',
    LOGIN_2FA_SETUP_REQUIRED: 'To-faktor-autentificering skal konfigureres',
    LOGIN_UNAUTHORIZED:
      'Brugeren blev ikke fundet, eller adgangskoden matchede ikke',
    LOGIN_TOO_MANY_REQUESTS: 'For mange loginforsøg. Prøv igen senere.',
    IN: 'i',
    MEMBERSHIP_CARD_SELECT: 'Vælg',
    MEMBERSHIP_CARD_SAVE: 'Spar',
    MEMBERSHIP_CARD_ANNUAL_FAQ: 'Find vores FAQ for årsabonnement',
    MEMBERSHIP_CARD_ANNUAL_FAQ_LINK: 'her',
    MEMBERSHIP_CARD_ANNUAL_DISCLAIMER:
      'Lige nu er årsabonnement kun tilgængeligt for Base',
    MEMBERSHIP_CARDS_EXPLORE_ALL: 'Udforsk alle',
    MEMBERSHIP_CARDS_FEATURED: 'Udvalgte',
    MEMBERSHIP_CARDS_STUDIOS: 'studios',
    MEMBERSHIP_STEPPER_SELECT_MEMBERSHIP: 'Vælg medlemskab',
    MEMBERSHIP_STEPPER_SIGNUP: 'Opret konto',
    MEMBERSHIP_STEPPER_PAYMENT: 'Betaling',
    MONTH: 'måned',
    MONTH_SHORT: 'md.',
    MONTHLY: 'Månedlig',
    OPEN_APP_BUTTON: 'Åbn i app',
    OPEN_APP_DEEP_LINK_NOTICE:
      'Åbnede appen ikke? Nogle browsere, som SnapChat og Messenger, understøtter ikke at åbne appen direkte. Prøv at åbne linket i en anden browser.',
    PAYMENT_DETAILS_TITLE: 'Betalingsoplysninger',
    PAYMENT_DETAILS_ADD_NEW_PAYMENT_METHOD: 'Tilføje ny betalingsmetode',
    PAYMENT_DETAILS_PAY: 'Betal',
    PAYMENT_DETAILS_CHOOSE_PAYMENT_METHOD: 'Vælg betalingsmetode',
    PAYMENT_DETAILS_TRY_AGAIN: 'Forsøg igen',
    PAYMENT_DETAILS_ANNUAL_INFO:
      'Bemærk, at udbuddet af studier og hold hos Bruce Studios kan ændre sig, selv mens du er i bindingsperioden. Læs mere i vores',
    PAYMENT_DETAILS_FAQ: 'FAQ',
    PAYMENT_DETAILS_MEMBERSHIP_PAYMENT_INFO:
      'Første gang du bruger Bruce Studios, kan du opsige dit medlemskab i løbet af den første måned uden opsigelsesvarsel. Derefter gælder 1 måneds opsigelsesvarsel. Det betyder, at du bliver opkrævet én gang mere efter opsigelsen. Læs mere i vores',
    PAYMENT_DETAILS_TERMS: 'brugervilkår',
    SHOPPING_CART_TITLE: 'Indkøbskurv',
    SHOPPING_CART_DISCOUNT: 'Rabat',
    SHOPPING_CART_CAMPAIGN: 'Kampagne',
    SHOPPING_CART_ANNUAL_CONTRACT_PERIOD: 'Årlig kontraktperiode',
    SHOPPING_CART_START_DATE: 'Startdato',
    SHOPPING_CART_END_DATE: 'Slutdato',
    SHOPPING_CART_PAYMENT_PLAN: 'Betalingsplan',
    SHOPPING_CART_PREPAID: 'Forudbetalt',
    SHOPPING_CART_TO_PAY: 'At betale:',
    SHOPPING_CART_TO_PAY_TODAY: 'At betale i dag:',
    SHOPPING_CART_PAY_TODAY: 'Betal i dag',
    SHOPPING_CART_VALID_UNTIL: 'Gyldig indtil',
    SHOPPING_CART_TRY_FOR_FREE: 'Prøv gratis',
    SHOPPING_CART_MEMBERSHIP: 'Medlemskab:',
    SHOPPING_CART_CAMPAIGN_CODE: 'Kampagnekode',
    SHOPPING_CART_CAMPAIGN_CODE_ACTIVATE: 'Aktivér',
    SHOPPING_CART_TRIAL_TRANSITION: ['Den', 'trækkes det første beløb på'],
    SHOPPING_CART_GIFT_CARD: 'gavekort',
    SHOPPING_CART_GIFT_CARD_MESSAGE: 'Personlig besked (valgfri)',
    SHOW_LESS: 'Vis mindre',
    SHOW_MORE: 'Vis mere',
    SIGNUP_INVITE_CODE: 'Invitations kode',
    SIGNUP_EMAIL: 'E-mail',
    SIGNUP_FIRST_NAME: 'Fornavn',
    SIGNUP_LAST_NAME: 'Efternavn',
    SIGNUP_YOUR_EMAIL: 'Din e-mail',
    SIGNUP_YOUR_FIRST_NAME: 'Dit fornavn',
    SIGNUP_YOUR_LAST_NAME: 'Dit efternavn',
    SIGNUP_PASSWORD: 'Adgangskode',
    SIGNUP_EMAIL_INVALID: 'Ugyldig e-mail',
    SIGNUP_FIRST_NAME_REQUIRED: 'Fornavn skal indtastes',
    SIGNUP_LAST_NAME_REQUIRED: 'Efternavn skal indtastes',
    SIGNUP_PASSWORD_MIN_LENGTH: 'Adgangskoden skal være på mindst 8 tegn',
    SIGNUP_AGREE: ['Jeg accepterer Bruce Studios', 'og'],
    SIGNUP_TERMS: 'medlemsvilkår',
    SIGNUP_PRIVACY_POLICY: 'privatlivspolitik',
    SIGNUP_MARKETING_OPT_IN:
      'Jeg accepterer at modtage markedsføringsmails fra Bruce Studios.',
    SIGNUP_MARKETING_OPT_IN_MORE_INFO: 'Mere info',
    SIGNUP_CONTINUE: 'Fortsæt',
    SIGNUP_WITH: 'med',
    SIGNUP_APP: 'Allerede medlem? Klik her',
    SIGNUP_LOGIN: 'Har du allerede en konto? Log ind her',
    SIGNUP_OR_WITH_SOCIAL: 'Eller tilmeld dig med:',
    STUDIO_MARKER_VIEW_STUDIO: 'Se studio',
    TRIAL_BUTTON: 'Prøv gratis i 14 dage',
    TRIAL_BUTTON_SHORT: 'Prøv gratis',
    TRIAL_TITLE: 'Trial',
    TRIAL_META_TITLE: 'Prøv gratis i 14 dage',
    TRIAL_USP_TITLE: 'Prøv gratis i 14 dage',
    TRIAL_USPS: [
      '1 besøg pr. studio.',
      'Afmeld når som helst før prøveperioden udløber.',
      'Prøv alle studios i Black i 14 dage.',
      'Efter prøveperioden bliver du automatisk Black-medlem med fuld adgang.',
      'Påmindelse via mail sendes to dage før prøveperioden overgår til et betalende medlemskab.',
    ],
    TRIAL_READ_MORE: 'Læs mere',
    TRIAL_STEP: ['Step 1 af 2', 'Step 2 af 2'],
    TRIAL_DISCLAIMER: [
      'Efter prøveperioden slutter, vil du automatisk starte et',
      'medlemskab for',
      'per måned. Hvis du vil afslutte prøveperioden, vil din adgang til studiosene stoppe. Regler for no show, for sen afmelding og for sen tjek ind er de samme, som for et normalt medlemskab.',
    ],
    TRIAL_DISCLAIMER_READ_MORE: 'Læs mere her',
    TRIAL_FEATURED_STUDIOS_TITLE: 'Prøv disse studios og mange flere',
    TRIAL_MORE_QUESTIONS: 'Har du flere spørgsmål? Besøg vores',
    TRIAL_FAQ_LINK: 'FAQ side',
    TRIAL_NOT_ACTIVE: 'Trial er i øjeblikket ikke tilgængelig i',
    USER_DETAILS_TITLE: 'Dine oplysninger',
    USER_DETAILS_NAME: 'Navn',
    USER_DETAILS_PERSONAL_IDENTITY_NUMBER: 'Personnummer/CPR',
    USER_DETAILS_MANUALLY_VERIFIED: 'Manuelt verificeret',
    USER_DETAILS_VERIFIED_WITH: 'Verificeret med',
    USER_DETAILS_CONTINUE_WITH: 'Fortsæt med',
    USER_DETAILS_APPROVE_WITH_MIT_ID: 'Godkend med',
    USER_DETAILS_MOBILE_BANK_ID: 'Mobilt BankID på en anden enhed',
    USER_DETAILS_EXTEND_QR_CODE: 'Forlæng',
    USER_DETAILS_DONT_HAVE_EID_PROVIDER: 'Har du ikke noget',
    USER_DETAILS_CONTACT_SUPPORT: 'Kontakt vores support for at få hjælp',
    USER_DETAILS_USER_ALREADY_EXISTS:
      'En bruger med dette personnummer findes allerede, men med en anden email end den indtastede her. Har du ikke adgang til denne email?',
    USER_DETAILS_TRY_AGAIN: 'Forsøg igen',
    USER_DETAILS_SOMETHING_WENT_WRONG: 'Noget gik galt med verificeringen.',
  },
} as const
